import { createSlice } from "@reduxjs/toolkit";
import { AFE_CHECKLIST } from "../../incpection.com/data/afe_data";

const generateInitialState = () => {
  const state = {};

  AFE_CHECKLIST.forEach((item) => {
    state[item.key] = item.key === "d"; // default: only "d" is true
  });

  return state;
};

const initialState = generateInitialState();

const afe_checkListSlice = createSlice({
  name: "afe_list",
  initialState,
  reducers: {
    toggleCheck: (state, action) => {
      const key = action.payload;

      if (!(key in state)) return;

      if (key === "d") {
        // Toggle "d" → everything else becomes false
        const newValue = !state[key];

        Object.keys(state).forEach((k) => (state[k] = false));
        state["d"] = newValue;
      } else {
        // Toggle a/b/c → uncheck d
        state[key] = !state[key];
        state["d"] = false;
      }
    },

    setAFEIntial: (state, action) => {
      Object.assign(state, action.payload);
    },

    resetChecks: (state) => {
      Object.keys(state).forEach((key) => {
        state[key] = key === "d"; // default state
      });
    },
  },
});

export const { toggleCheck, resetChecks, setAFEIntial } =
  afe_checkListSlice.actions;

export default afe_checkListSlice.reducer;
